import { useState, useRef, useEffect } from 'react';
import { Box, Circle } from '@chakra-ui/react';

export const MobileJoystick = ({ onMove, isActive }) => {
  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const containerRef = useRef(null);
  const baseRadius = 50;
  const handleRadius = 20;
  const maxDistance = baseRadius - handleRadius;

  useEffect(() => {
    if (!isDragging) {
      setPosition({ x: 0, y: 0 });
      onMove?.(0, 0);
    }
  }, [isDragging]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleMove = (e) => {
    if (!containerRef.current) return;
    e.preventDefault();

    const touch = e.touches?.[0] || e;
    const rect = containerRef.current.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;

    let deltaX = touch.clientX - centerX;
    let deltaY = touch.clientY - centerY;

    const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
    if (distance > maxDistance) {
      const angle = Math.atan2(deltaY, deltaX);
      deltaX = Math.cos(angle) * maxDistance;
      deltaY = Math.sin(angle) * maxDistance;
    }

    setPosition({ x: deltaX, y: deltaY });
    onMove?.(deltaX / maxDistance, -deltaY / maxDistance);
  };

  const handleStart = (e) => {
    e.preventDefault();
    setIsDragging(true);
    handleMove(e);
  };

  const handleEnd = () => setIsDragging(false);

  const isTouchDevice = 'ontouchstart' in window;
  if (!isTouchDevice || !isActive) return null;

  return (
    <Box
      position="fixed"
      bottom="20px"
      left="20px"
      zIndex="modal"
      opacity={isDragging ? 0.8 : 0.6}
    >
      <Box
        ref={containerRef}
        position="relative"
        width={`${baseRadius * 2}px`}
        height={`${baseRadius * 2}px`}
        onTouchStart={handleStart}
        onTouchMove={isDragging ? handleMove : undefined}
        onTouchEnd={handleEnd}
        onMouseDown={handleStart}
        onMouseMove={isDragging ? handleMove : undefined}
        onMouseUp={handleEnd}
        onMouseLeave={handleEnd}
        cursor={isDragging ? 'grabbing' : 'grab'}
        style={{ touchAction: 'none' }}
      >
        <Circle
          size={`${baseRadius * 2}px`}
          bg="whiteAlpha.200"
          border="2px solid"
          borderColor="whiteAlpha.600"
          position="absolute"
          top="0"
          left="0"
        />
        <Circle
          size={`${handleRadius * 2}px`}
          bg="orange.500"
          border="2px solid"
          borderColor="orange.300"
          position="absolute"
          top="50%"
          left="50%"
          transform={`translate(calc(-50% + ${position.x}px), calc(-50% + ${position.y}px))`}
          transition={isDragging ? 'none' : 'transform 0.2s ease-out'}
          boxShadow="0 2px 8px rgba(0,0,0,0.3)"
        />
      </Box>
    </Box>
  );
};
